import React from 'react';
import PropTypes from 'prop-types';
import { levelLabel } from './linksPuzzles';
import { generationShape } from './LinksGeneratePane';
import './links.css';

// The latest generation per upcoming date that is still running or failed;
// a finished one is its draft in the list.
export default function LinksGenerations({ generations }) {
    const shown = generations.filter(g => g.status !== 'done');
    if (!shown.length) return null;
    return (
        <ul className="lk-generations">
            {shown.map(g => (
                <li key={g.id} className={`lk-generation lk-generation-${g.status}`}>
                    <strong>{g.date}</strong>
                    <span className={`lk-level lk-level-${g.level}`}>{levelLabel(g.level)}</span>
                    {g.status === 'running'
                        ? <span>Generating… {g.progress || 'queued'}</span>
                        : <span>Failed: {g.error}</span>}
                </li>
            ))}
        </ul>
    );
}

LinksGenerations.propTypes = { generations: PropTypes.arrayOf(generationShape).isRequired };
